// extracted by mini-css-extract-plugin
export var chevronIcon = "_dq-2";
export var teamName = "_dq-1";
export var teamSwitcherButton = "_dq-0";